import { Plus, Trash2 } from 'lucide-react';
import type { Diagnostic } from '../../api/types';
import { IconButton } from '../../components/ui';
import { strings } from '../../strings';
import { NetworkDiagnostic } from '../lists/parts';

const t = strings.networks.topology;

/** The allowed host names of a firewall (spec 11 6.15.12): one field per row with Remove, Add, diagnostics at the row. */
export function AllowedEgressList({
  hosts,
  readOnly,
  help,
  diagnosticsAt,
  onChange,
}: {
  hosts: readonly string[];
  readOnly: boolean;
  help: string;
  diagnosticsAt: (index: number) => Diagnostic[];
  onChange: (hosts: string[]) => void;
}) {
  return (
    <fieldset className="sm:col-span-2">
      <legend className="label">{t.allowedEgress}</legend>
      <p className="help mb-2">{help}</p>
      <ul className="space-y-2">
        {hosts.map((host, i) => {
          const rowDiagnostics = diagnosticsAt(i);
          return (
            <li key={i}>
              <div className="flex items-center gap-2">
                <input
                  className="input max-w-sm font-mono"
                  aria-label={t.hostLabel(i + 1)}
                  value={host}
                  readOnly={readOnly}
                  aria-invalid={rowDiagnostics.some((d) => d.severity === 'error') || undefined}
                  onChange={(e) => onChange(hosts.map((h, j) => (j === i ? e.target.value : h)))}
                />
                {!readOnly && (
                  <IconButton
                    label={t.removeHost(host)}
                    onClick={() => onChange(hosts.filter((_, j) => j !== i))}
                  >
                    <Trash2 aria-hidden className="size-4" />
                  </IconButton>
                )}
              </div>
              {rowDiagnostics.map((d, k) => (
                <p key={k} className="mt-1">
                  <NetworkDiagnostic diagnostic={d} />
                </p>
              ))}
            </li>
          );
        })}
      </ul>
      {!readOnly && (
        <button type="button" className="btn btn-sm mt-2" onClick={() => onChange([...hosts, ''])}>
          <Plus aria-hidden className="size-4" />
          {t.addHost}
        </button>
      )}
    </fieldset>
  );
}
